<div id="loadingOverlay" *ngIf="loadingService.isLoading | async">
  <h3 id="heading">Loading...</h3>
</div>
<router-outlet></router-outlet>
